import axios from 'axios';
import {
  fakeFormShareApi,
  harnessShareOverrides,
  isFormShareHarnessActive,
} from '@/utils/form-share-harness';

// The two form-share routes (hogc-one-api FormShareController, flag
// `form-share-links`). While the dev harness is on (/form-share-states) the calls
// go to its fake instead.

const authHeaders = token => ({ headers: { Authorization: `Bearer ${token}` } });

export const sharedFormUrl = formTitle =>
  `${process.env.VUE_APP_API_URL}/form/shared/${encodeURIComponent(formTitle)}`;

const shareLinkUrl = formTitle =>
  `${process.env.VUE_APP_API_URL}/form/share-link/${encodeURIComponent(formTitle)}`;

/** The raw Strapi form a share link opens for this member. Throws on a refusal (404). */
export async function fetchSharedForm(formTitle, token) {
  if (isFormShareHarnessActive()) return fakeFormShareApi.getSharedForm(formTitle);
  const { data } = await axios.get(sharedFormUrl(formTitle), authHeaders(token));
  return data?.data;
}

/** The form's hogc.one link, made on the first share. */
export async function createFormShareLink(formTitle, token) {
  if (isFormShareHarnessActive()) return fakeFormShareApi.createShareLink(formTitle);
  const { data } = await axios.post(shareLinkUrl(formTitle), null, authHeaders(token));
  return data?.shortUrl || null;
}

/**
 * May this member share this form? Only a leader, and only a form in their OWN
 * list marked `leadersCanShare` — one reached through someone else's link is one
 * the API would refuse to let them re-share. The feature flag is the caller's.
 */
export function canLeaderShareForm({ isLeader, formTitle, ownForm }) {
  if (!ownForm) return false;
  const facts = { isLeader, formTitle, leadersCanShare: ownForm.leadersCanShare };
  const { isLeader: leader, leadersCanShare } = isFormShareHarnessActive()
    ? harnessShareOverrides(facts)
    : facts;
  return Boolean(leader && leadersCanShare);
}
